import React from 'react';
import Banner from '../Includes/Home/Banner/Banner';
import Section1 from '../Includes/Home/Section1/Section1';
import Section2 from '../Includes/Home/Section2/Section2';
import Section3 from '../Includes/Home/Section3/Section3';
import Section4 from '../Includes/Home/Section4/Section4';

const Home = ()=>{

    return(
        <>
            <Banner/>
            <Section1/>
            <Section2/>
            <Section3/>
            <Section4/>
        </> 
    );

}

export default Home;